import { useCurrentUser } from "@/lib/api/user";
import { isMentorIdentity } from "@/lib/utils/system-roles";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile/")({
  component: ProfileIndex,
});

function ProfileIndex() {
  const { data: user } = useCurrentUser();

  if (!user) return null;

  if (isMentorIdentity(user.systemRoles)) {
    return <Navigate to="/profile/matching" />;
  }

  return <Navigate to="/profile/account" />;
}
